import { ConfirmResult } from "../enums";

export type IDialogVariant = "default" | "custom";
export type IDialogOrder = "top" | "default";
export enum DialogType {
  Info = "Info",
  BookingBulkSetConflictApprovalReason = "BookingBulkSetConflictApprovalReason",
  BookingBulkSetConflictApprovalReasonMultiPassengers = "BookingBulkSetConflictApprovalReasonMultiPassengers",
  BulkArchiveRelationErrorDisplayDialog = "BulkArchiveRelationErrorDisplayDialog",
  RideConfirm = "RideConfirm",
}

export type IDialogProps = Record<string, unknown>;

export type IDialogContainerProps = IDialogProps & {
  onClose: () => void;
};

export interface IDialog {
  dialogName: DialogType;
  variant?: IDialogVariant;
  dialogProps?: IDialogProps & Record<string, unknown>;
  order?: IDialogOrder;
}

export interface ICompareResult {
  changesList?: IChangedDataItem[];
  confirmed: boolean;
}

export interface IChangedDataItem {
  label: string;
  fieldName: string;
  oldLabel: string;
  newLabel: string;
  oldValue: number | null;
  newValue: number | null;
}

export interface IDataChangedModalPayload {
  changesList: IChangedDataItem[];
  resolveFn: (value: ConfirmResult) => void;
}
